import { useLang } from 'hooks/lang';

import { outsourceInvoiceStatusConfig } from 'entities';

import { Column, Tabs } from 'components/Blocks';
import { GoBackButton } from 'components/Buttons';

import { OutsourceInvoiceByStatus } from './ByStatus';
import { ActiveOutsourceInvoices } from './Active';

import { useUrlStateV2 } from 'hooks';

const tabs = ['active', 'paid', 'canceled'];

type TabConfig = Record<string, { tab: string; Component: typeof ActiveOutsourceInvoices }>;

const tabComponents: TabConfig = {
  [outsourceInvoiceStatusConfig.paid.queryParam]: {
    Component: OutsourceInvoiceByStatus,
    tab: 'paid',
  },

  [outsourceInvoiceStatusConfig.canceled.queryParam]: {
    Component: OutsourceInvoiceByStatus,
    tab: 'canceled',
  },

  [outsourceInvoiceStatusConfig.pendingConfirmation.queryParam]: {
    Component: ActiveOutsourceInvoices,
    tab: 'active',
  },

  [outsourceInvoiceStatusConfig.registered.queryParam]: {
    Component: ActiveOutsourceInvoices,
    tab: 'active',
  },

  [outsourceInvoiceStatusConfig.waitingPayment.queryParam]: {
    Component: ActiveOutsourceInvoices,
    tab: 'active',
  },
};

const defaultTab: TabConfig[string] = {
  Component: ActiveOutsourceInvoices,
  tab: 'active',
};

function OutsourceInvoices(): JSX.Element {
  const { t } = useLang();

  const [queryParams, setQueryParams] = useUrlStateV2({
    status: 'active',
  });

  const handleTabChange = (status: string): void => {
    setQueryParams({ status });
  };

  const { Component, tab } = tabComponents[queryParams.status] ?? defaultTab;

  return (
    <Column>
      <Column gap="2">
        <h5 className="flex items-center gap-2 text-3xl font-medium text-primary">
          <GoBackButton />

          {t('outsource-invoices')}
        </h5>

        <Tabs
          value={tab}
          onTabChange={handleTabChange}
          tabs={tabs.map((value) => ({
            value,
            getLabel: (t) => t(value) as string,
          }))}
        />
      </Column>

      <Component key={queryParams.status} tab={tab} />
    </Column>
  );
}

export default OutsourceInvoices;
